import { notifyMutationError } from '@inquiries/-lib/handleInquiryCompletedError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { deleteInquiryAssign } from '@/lib/apiClients/inquiries'
import { queryKeys } from '@/lib/queryKeys'

export function useDeleteInquiryAssign(inquiryId: number) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (inquiryAssignId: number) => {
      return deleteInquiryAssign(inquiryId, inquiryAssignId)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.assigns(inquiryId) })
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.actionLogs(inquiryId) })
      toast.success('アサインを削除しました')
    },
    onError: (error: Error) => {
      notifyMutationError(error, 'アサインの削除に失敗しました')
    },
  })
}
